/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UwSettings } from '../../models/uw-settings';

export interface GetWidgetAttributes$Params {
  orid?: number;
  uwid?: number;
}

export function getWidgetAttributes(http: HttpClient, rootUrl: string, params?: GetWidgetAttributes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<UwSettings>>> {
  const rb = new RequestBuilder(rootUrl, getWidgetAttributes.PATH, 'get');
  if (params) {
    rb.query('orid', params.orid, {});
    rb.query('uwid', params.uwid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<UwSettings>>;
    })
  );
}

getWidgetAttributes.PATH = '/api/DashboardManagement/getWidgetAttributes';
